import { Component, OnInit } from "@angular/core";
import { DataElement } from "src/app/shared/models/common";
import { BroshService } from "src/app/shared/services/brosh.service";
import { SupplyTypesEnum } from "src/app/shared/models/order.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { Clinic } from "src/app/shared/models/clinic.model";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import {
  CREATE_SUPPLY_ORDER,
  REQUEST_DASHBOARD_REFRESH,
  SELECT_SUPPLY_TYPE,
  SUPPLIES_SELECT_CLINIC,
} from "src/app/shared/ngrx/ngrx-actions";
import {
  clinicList,
  selectedSupplyType,
  supplyTypesList,
} from "src/app/shared/ngrx/ngrx-selectors";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { LoaderComponent } from "src/app/shared/components/ui/loader/loader.component";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SpinnerComponent } from "src/app/shared/components/ui/spinner/spinner.component";
import { ClearMultiComponent } from "src/app/shared/components/ui/clear-multi.component";
import { SelectModule } from "primeng/select";

@Component({
  selector: "create-supplies-order",
  templateUrl: "./create-supplies-order.component.html",
  styleUrls: ["./create-supplies-order.component.scss"],
  standalone: true,
  imports: [
    TranslateModule,
    LoaderComponent,
    InputWrapComponent,
    SelectModule,
    CommonModule,
    FormsModule,
    SpinnerComponent,
    ClearMultiComponent,
  ],
})
export class CreateSuppliesOrderComponent implements OnInit {
  selectedClinic: Clinic;
  notes: string;
  sending: boolean;
  //selectedSupplyType: DataElement;
  displayClinicFields: boolean;
  destroy$ = new Subject();
  clinicList: Clinic[];
  supplyTypes: DataElement[];

  constructor(
    private readonly store: Store,
    private broshService: BroshService,
    private authService: AuthService,
    private actions$: Actions,
    private translateService: TranslateService
  ) {
    this.displayClinicFields = this.authService.currentUser.org == "LAB" || this.authService.currentUser.isMultiClinicUser;
  }

  ngOnInit(): void {
    this.store
      .select(clinicList)
      .pipe(take(1))
      .subscribe((sm) => {
        this.clinicList = sm;
        if (this.clinicList.length == 1) {
          this.selectedClinic = this.clinicList[0];
        }
      });

    this.store
      .select(supplyTypesList)
      .pipe(take(1))
      .subscribe((supplyTypesList) => {
        this.supplyTypes = supplyTypesList;
        this.supplyTypes.map((i) => (i.selected = false));
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  onItemSelect(item: DataElement) {
    item.selected = !item.selected;
  }

  public allowSubmit(): boolean {
    return (
      this.selectedClinic &&
      this.supplyTypes.filter((s) => s.selected).length > 0
    );
  }

  createOrder() {
    this.sending = true;
    this.broshService
      .createSupplyOrder(
        this.selectedClinic,
        this.supplyTypes.filter((s) => s.selected),
        this.notes
      )
      .subscribe(
        (rep) => {
          if (rep == null) {
            this.afterOrderCreate();
            return;
          } else if (this.selectedClinic.deliveryApiSw && rep.deliveryOrderId) {
            this.approveOrder(rep.deliveryOrderId);
          } else {
            this.afterOrderCreate();
          }
        },
        (err) => {
          this.sending = false;
        }
      );
  }

  approveOrder(orderId: number) {
    this.broshService.approveSupplyOrder(orderId).subscribe(
      () => {
        this.broshService.mailSuppliesOrders(orderId).subscribe(
          (data) => {
            this.afterOrderCreate();
          },
          (err) => {
            this.afterOrderCreate();
          }
        );
      },
      (err) => {
        this.afterOrderCreate();
      }
    );
  }

  afterOrderCreate() {
    this.sending = false;
    this.notes = "";
    if (this.clinicList.length > 1) this.selectedClinic = null;
    this.supplyTypes.forEach((t) => (t.selected = false));

    this.store.dispatch(CREATE_SUPPLY_ORDER());
    this.store.dispatch(REQUEST_DASHBOARD_REFRESH());
  }

  onClinicChange() {
    this.store.dispatch(
      SUPPLIES_SELECT_CLINIC({
        clinic: this.selectedClinic,
      })
    );
  }

  clearClinic() {
    this.selectedClinic = null;
    this.onClinicChange();
  }

  isSelected(item: DataElement) {
    return item.selected;
  }

  getIconPath(supplyType: DataElement): string {
    switch (supplyType.id) {
      case SupplyTypesEnum.SMALL_BAG:
        return this.isSelected(supplyType)
          ? "assets/img/supplies/Small_Bag_Green.svg"
          : "assets/img/supplies/Small_Bag_Blue.svg";
      case SupplyTypesEnum.LARGE_BAG:
        return this.isSelected(supplyType)
          ? "assets/img/supplies/Large_Bag_Green.svg"
          : "assets/img/supplies/Large_Bag_Blue.svg";
      case SupplyTypesEnum.DELIVERY:
        return this.isSelected(supplyType)
          ? "assets/img/supplies/Scooter_Green.svg"
          : "assets/img/supplies/Scooter_Blue.svg";
      case SupplyTypesEnum.DENTURE_ORDER_FORM:
        return this.isSelected(supplyType)
          ? "assets/img/supplies/R_File_Green.svg"
          : "assets/img/supplies/R_File_Blue.svg";
      case SupplyTypesEnum.CROWN_ORDER_FORM:
        return this.isSelected(supplyType)
          ? "assets/img/supplies/F_File_Green.svg"
          : "assets/img/supplies/F_File_Blue.svg";
      case SupplyTypesEnum.BARCODE_ROLL:
        return this.isSelected(supplyType)
          ? "assets/img/supplies/Barcode_Roll_Green.svg"
          : "assets/img/supplies/Barcode_Roll_Blue.svg";
      case SupplyTypesEnum.OTHER:
        return this.isSelected(supplyType)
          ? "assets/img/supplies/Three_Dots_Green.svg"
          : "assets/img/supplies/Three_Dots_Blue.svg";
      default:
        return null;
    }
  }
}
